import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { shortDateRangeFormat } from '~/modules/common/dates/format';
import { getQuarterFromMonth } from '~/modules/common/dates/quarter';
import { PERIOD_SCALE_ENUM } from '~/modules/common/charts/timeline';

export const generateScreenReaderHeaderItemText = ({ start, end, scale }) => {
  if (scale === PERIOD_SCALE_ENUM.DAYS) {
    return `${start.toLocaleString({ month: 'short' })} ${start.toLocaleString({
      day: 'numeric'
    })}`;
  }

  if (scale === PERIOD_SCALE_ENUM.WEEKS) {
    const weekFormat = shortDateRangeFormat({ start, end });

    return weekFormat.replace(/—/g, ' to ');
  }

  if (scale === PERIOD_SCALE_ENUM.QUARTERS) {
    const quarter = getQuarterFromMonth(start.month);
    const year = end.toLocaleString({ year: 'numeric' });
    const startMonth = start.toLocaleString({ month: 'short' });
    const endMonth = end.toLocaleString({ month: 'short' });

    return `Quarter ${quarter} ${year}, ${startMonth} to ${endMonth}`;
  }

  if (scale === PERIOD_SCALE_ENUM.YEARS) {
    return start.toLocaleString({ year: 'numeric' });
  }

  return start.toLocaleString({ month: 'long', year: 'numeric' });
};

const HeaderTimeItemContent = ({ scale, start, end }) => {
  if (scale === PERIOD_SCALE_ENUM.DAYS) {
    return (
      <>
        {start.toLocaleString({ month: 'short' })}
        <br />
        {start.toLocaleString({ day: 'numeric' })}
      </>
    );
  }
  if (scale === PERIOD_SCALE_ENUM.WEEKS) {
    return shortDateRangeFormat({ start, end });
  }

  if (scale === PERIOD_SCALE_ENUM.QUARTERS) {
    return (
      <>
        <FormattedMessage id="chart.quarterAbbreviated" />
        {getQuarterFromMonth(start.month)}{' '}
        {end.toLocaleString({ year: 'numeric' })}
        <br />
        {start.toLocaleString({ month: 'short' })} &mdash;{' '}
        {end.toLocaleString({ month: 'short' })}
      </>
    );
  }

  if (scale === PERIOD_SCALE_ENUM.YEARS) {
    return start.toLocaleString({ year: 'numeric' });
  }

  return start.toLocaleString({ month: 'long', year: 'numeric' });
};

HeaderTimeItemContent.propTypes = {
  scale: PropTypes.string,
  start: PropTypes.object,
  end: PropTypes.object
};

export default HeaderTimeItemContent;
